import { Button } from '@workspace/ui/common/Buttons/Button';

export type ButtonVariant = React.ComponentProps<typeof Button>['variant'];

export const toVariant = (style?: string): ButtonVariant => {
  const v = (style || '').toLowerCase();
  return v === 'primary' || v === 'secondary' || v === 'tertiary' ? (v as ButtonVariant) : 'primary';
};
